module.exports = __webpack_public_path__ + "img/Rocket.ae17ac22.svg";